import { render, staticRenderFns } from "./CourseInfoPage.vue?vue&type=template&id=63ada6b3&scoped=true"
import script from "./CourseInfoPage.vue?vue&type=script&lang=js"
export * from "./CourseInfoPage.vue?vue&type=script&lang=js"
import style0 from "./CourseInfoPage.vue?vue&type=style&index=0&id=63ada6b3&prod&lang=scss&scoped=true"
import style1 from "./CourseInfoPage.vue?vue&type=style&index=1&id=63ada6b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ada6b3",
  null
  
)

export default component.exports